import React from 'react';
import Logo from '@/components/svg/Logo';
import styles from './Logo.module.scss';
import { environments } from '@/environment';
import { BootService } from '@/services/boot';

const View: React.FC = () => {
  return (
    <a
      href={environments[BootService.env].portalUrl}
      className={styles.container}
    >
      <Logo className={styles.logo} />
      <div className={styles.name}>C360</div>
    </a>
  );
};

export default View;
